import React from 'react';

export const MessageFourth = ({
  width = '30',
  height = '30',
  fill = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 0C2.8455 0 1.5 1.3455 1.5 3V21C1.5 22.6545 2.8455 24 4.5 24H9.879L15 29.121L20.121 24H25.5C27.1545 24 28.5 22.6545 28.5 21V3C28.5 1.3455 27.1545 0 25.5 0H4.5ZM25.5 21H18.879L15 24.879L11.121 21H4.5V3H25.5V21Z"
        fill={fill}
      />
      <path
        d="M7.5 7.5H22.5V10.5H7.5V7.5ZM7.5 13.5H18V16.5H7.5V13.5Z"
        fill={fill}
      />
    </svg>
  );
};
